export const API_ERRORS = {
  BAD_REQUEST: 400,
  CONFLICT: 409,
  FAILED_DEPENDENCY: 424,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  NONE: 0,
  NOT_FOUND: 404,
  PAYLOAD_TOO_LARGE: 413,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422,
} as const
